document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('navigation')) {
        const navigation = document.getElementById('navigation');
        let is_menu_open = true;

        navigation.addEventListener('click', function () {
            const body = document.querySelector('body');
            const hamburguer = document.querySelector('.icon--hamburguer');
            const close = document.querySelector('.icon--close');
            const header = document.getElementById('header');

            if (is_menu_open) {
                hamburguer.style.display = 'none';
                close.style.display = 'block';
                header.classList.add('header--open');
                body.style.position = 'fixed';
                body.style.height = '100%';
                body.style.maxWidth = '100%';
            } else {
                hamburguer.style.display = 'block';
                close.style.display = 'none';
                header.classList.remove('header--open');
                body.removeAttribute('style');
            }

            is_menu_open = !is_menu_open;
        });
    }

    if (document.querySelector('.menu_lg--toggle')) {
        const menu_lg_toggle = document.querySelectorAll('.menu_lg--toggle');
        menu_lg_toggle.forEach(e => {
            e.addEventListener('click', () => {

                const menu_id = e.getAttribute('data-menu-id');

                const navigation = document.querySelector('.navigation_lg');
                const ul = navigation.querySelectorAll('ul');

                const currently_open_menu_id = navigation.getAttribute('data-opened-menu-id');

                const arrow_up = document.querySelectorAll('.icon--arrow_up');
                arrow_up.forEach((icon) => {
                    icon.classList.remove('icon--arrow_up');
                });

                if (currently_open_menu_id == menu_id) {
                    navigation.style.display = 'none';
                    ul.forEach((ul) => {
                        ul.style.display = 'none';
                    });

                    navigation.setAttribute('data-opened-menu-id', '');
                } else {
                    const icon = e.querySelector('.icon');
                    icon.classList.add('icon--arrow_up');

                    navigation.style.display = 'block';
                    ul.forEach((ul) => {
                        ul.style.display = 'none';
                    });

                    navigation.setAttribute('data-opened-menu-id', menu_id);

                    const menu = navigation.querySelector(`[data-menu-id='${menu_id}']`);
                    if (menu) {
                        const container = document.querySelector('.container_menu');
                        const distancy_x = e.getBoundingClientRect().left - container.getBoundingClientRect().left - 64;
                        menu.style.marginLeft = distancy_x + 'px';
                        menu.style.display = 'block';
                    }
                }
            });
        });
    }
});